import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { RouteAndPath, RouteName, RouteState } from './route.state';

const routPathNameSelector  = (state: RouteState) => (state as any).route.routeAndPath;

@Injectable({
  providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class RouteSelectors {
  constructor(private store: Store<any>) {
  }
  selectRoutesPath(): Observable<Partial<RouteAndPath>> {
    return this.store.pipe(select(routPathNameSelector));
  }
}
